// One language for account role/type across the admin portal.
// Precedence (highest privilege wins): super_admin (gold) > admin (red) >
// business (approved dealer, blue) > business_pending (dealer application pending, amber) > user (white).
// TEXT COLOR ONLY — never a background chip or border (verification chips own the filled look).
// super_admin + admin share the same red; super_admin reads as BOLD to separate the two.
export const ACCOUNT_ROLE_META = {
  super_admin: { key: "super_admin", label: "SUPER ADMIN", color: "#D9705A", bold: true, testid: "super-admin" },
  admin: { key: "admin", label: "ADMIN", color: "#D9705A", testid: "admin" },
  business: { key: "business", label: "BUSINESS", color: "#79B8E4", testid: "business" },
  business_pending: { key: "business_pending", label: "BUSINESS PENDING", color: "#f0b429", testid: "business-pending" },
  user: { key: "user", label: "USER", color: "#DAD6CE", testid: "user" },
};

const RANK = { super_admin: 0, admin: 1, business: 2, business_pending: 3, user: 4 };

export function resolveAccountKind(a = {}) {
  if (a && a.account_kind) return a.account_kind;
  if (a && a.role === "super_admin") return "super_admin";
  if (a && a.role === "admin") return "admin";
  if (a && a.is_dealer) return "business";
  if (a && a.is_dealer_applicant) return "business_pending";
  return "user";
}

export function roleRank(kind) {
  return RANK[kind] ?? 9;
}

// Admin access = admin OR super_admin (super sits above admin and inherits every admin power).
export function isAdminRole(role) {
  return role === "admin" || role === "super_admin";
}

export function isSuperAdmin(role) {
  return role === "super_admin";
}

// Admin and Super Admin carry IDENTICAL privileges; the only super-only power is role
// management (promote / demote / grant Super Admin) — gate that with isSuperAdmin.
export function hasSuperPrivileges(role) {
  return isAdminRole(role);
}

// Forum moderator = admin/super_admin OR the forum-scoped `is_forum_moderator` flag. This is
// DELIBERATELY not an admin role — a plain moderator gets ZERO admin-dashboard access; the flag
// only unlocks forum moderation (/mod + inline thread controls).
export function canModerateForum(user) {
  return !!user && (isAdminRole(user.role) || !!user.is_forum_moderator);
}

// Forum PARTICIPATION (post / reply / react / report / attach). Admin/super_admin/moderator are
// ALWAYS exempt (checked by role, so they pass even if the server-computed flag is stale/missing on
// a cached mobile session). Everyone else must be an entitled member (`forum_participant` from
// /auth/me: membership-plan subscribers, Founding, Dealer, Ambassador — NOT the browse-only Buyer
// Pass). Reading is always open.
export function canParticipateInForum(user) {
  if (!user) return false;
  if (canModerateForum(user)) return true; // admin / super_admin / forum moderator
  return !!user.forum_participant;
}
